const Threshold = {
  phone: '700px',
  tabletSmall: '900px',
  tablet: '1200px',
  desktop: '1440px',
  desktopLarge: '1920px'
}

export default Threshold
